var React = require('react');

function Profile (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.2935 8.29064C18.2935 11.2274 15.9387 13.5823 12.9999 13.5823C10.062 13.5823 7.7063 11.2274 7.7063 8.29064C7.7063 5.35384 10.062 3 12.9999 3C15.9387 3 18.2935 5.35384 18.2935 8.29064ZM12.9994 23.0018C8.66209 23.0018 5 22.2968 5 19.577C5 16.8562 8.6851 16.1762 12.9994 16.1762C17.3377 16.1762 20.9988 16.8812 20.9988 19.601C20.9988 22.3218 17.3137 23.0018 12.9994 23.0018Z","fill":"white"}));
}

Profile.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = Profile;

Profile.default = Profile;
